<div class="wrapper limit-width-on-desktop-float" >
  <div class="top-heading">
    <h2 class="h2-bold">Spread the word</h2>
    <p>Want to recommend this way of doing short-term insurance? We’ll send them an email right away!</p>
  </div>
  <div class="form">
    <ion-item mode="ios">
      <ion-input labelPlacement="floating" autocapitalize="on" type="text" [(ngModel)]="friendName">
        <div slot="label">
          <ion-text class="standard-input-label">My friend’s name</ion-text>
        </div>
      </ion-input>
    </ion-item>
    <ion-item mode="ios">
      <ion-input labelPlacement="floating" autocapitalize="on" type="text" [(ngModel)]="friendSurname">
        <div slot="label">
          <ion-text class="standard-input-label">My friend’s surname</ion-text>
        </div>
      </ion-input>
    </ion-item>
    <ion-item mode="ios" class="email">
      <ion-input labelPlacement="floating" type="email" [(ngModel)]="friendEmail" (ionInput)="checkEmail($event)">
        <div slot="label">
          <ion-text class="standard-input-label">My friend’s email address</ion-text>
        </div>
      </ion-input>
    </ion-item>
    <p class="error-message" *ngIf="errorText">{{ errorText }}</p>
    <div class="button-div">
      <ion-button mode="ios" class="primary-button" (click)="send()" [disabled]="!friendName || !friendSurname || !friendEmail || errorText">
        Send
      </ion-button>
    </div>
  </div>
</div>

<!-- TODO ALL OTHER POPUPS SHOULD BE REPLACED BY THIS GENERIC POPUP -->
<popup-dialog  id="referral.component" *ngIf="sharedConfig.popupDialogShow"></popup-dialog>
